import { api } from "@/core/api/client";

import { collectDeviceProfile } from "./profile";

/** Writes this browser's device profile onto the current portal session. */
export async function reportCurrentDevice(tenant: string): Promise<void> {
  const device = await collectDeviceProfile();
  await api.account(tenant, "/sessions/current/device", {
    method: "POST",
    body: JSON.stringify({ device }),
  });
}
